<script setup>
import {computed} from "vue"
import {usePage} from "@inertiajs/vue3"
import {useNotify} from "@/Services/useNotify.js"

const {notifications, removeNotification} = useNotify()
const page = usePage()

// Controla a exibição do diálogo
const showDialog = computed(() => notifications.value.length > 0)
const notification = computed(() => notifications.value[0] || {})

const dialogOptions = computed(() => ({
    color: notification.value.color,
    confirmText: notification.value.confirmText,
    cancelText: notification.value.cancelText || null,
}))

const closeDialog = () => {
    removeNotification()
}
</script>

<template>
    <v-dialog v-model="showDialog" :max-width="$vuetify.display.mobile ? '90vw' : '70vw'">
        <v-card
            class="mx-auto"
            max-width="60%"
            hover
        >
            <v-card-item>
                <v-card-title class="text-center pa-6 mt-1 text-white d-flex align-center justify-center" :class="`bg-${dialogOptions.color}`">
                    <v-icon
                        v-if="dialogOptions.color === 'error'"
                        class="mr-2"
                        color="white"
                        size="48"
                    >
                        mdi-alert-circle-outline
                    </v-icon>

                    <v-icon
                        v-if="dialogOptions.color === 'success'"
                        class="mr-2"
                        color="white"
                        size="48"
                    >
                        mdi-check-circle
                    </v-icon>

                    <v-icon
                        v-if="dialogOptions.color === 'warning'"
                        class="mr-2"
                        color="white"
                        size="48"
                    >
                        mdi-alert-outline
                    </v-icon>

                    Notificação
                </v-card-title>
            </v-card-item>
            <v-card-text class="text-center pa-6 py-4">
                <v-sheet v-html="notification.message"/>
            </v-card-text>
            <v-card-actions class="pr-6 py-4">
                <v-row justify="end" class="pa-2 mb-1">
                    <v-btn class="mx-2 bg-primary" variant="flat" :text="dialogOptions.confirmText" @click="closeDialog"/>
                    <v-btn v-if="dialogOptions.cancelText" class="mx-2 bg-secondary" :text="dialogOptions.cancelText" @click="closeDialog"/>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
